module.exports = __webpack_public_path__ + "img/mapHourse.6256ec9e.png";